import Button, { ButtonProps } from "@/shared/form/button";
import { BellOutlined } from "@ant-design/icons";
import { twMerge } from "tailwind-merge";
import { usePalette } from "@/shared/theme";
import { CSSProperties } from "react";

export function BellButton({ className, style, ...props }: ButtonProps) {
  const palette = usePalette();

  return (
    <Button
      shape={"circle"}
      icon={<BellOutlined />}
      className={twMerge("bg-[--bg-color]", className)}
      style={
        {
          ...style,
          "--bg-color": palette.primary[0],
        } as CSSProperties
      }
      {...props}
    />
  );
}
